<span>近7日平均温度</span>
<div id="wenduList" style="width: 100%; height: 300px"></div>
